import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ComplaintReasonVisibleType, ComplaintType } from '@libs/shared/api';
import {
  ComplaintDialogComponent,
  ComplaintDialogResultData,
} from '@libs/shared/ui/dialogs/complaint-dialog/complaint-dialog.component';

@Injectable()
export class ComplaintDialogService {
  readonly matDialog = inject(MatDialog);

  open(
    complaintType: ComplaintType,
    visibleType: ComplaintReasonVisibleType
  ): MatDialogRef<ComplaintDialogComponent, ComplaintDialogResultData> {
    return this.matDialog.open(ComplaintDialogComponent, {
      autoFocus: true,
      disableClose: false,
      data: { complaintType, visibleType },
    });
  }
}
